























































import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'FormFieldInventoryCapacity'

  vue:
    props: ['value', 'errors']

    components: {
      FormField,
    }

    data: ->
      engagementCapacity: @value || {}
      minimumPurchasePriceInDollars: null

    mounted: ->
      @setDefaultEngagementCapacity()
      @loadMinimumPurchasePrice()

    computed:
      segment: -> 'default'

    methods:
      hiInputChanged: ->
        @inputChanged()

      hiSetMinimumPurchasePrice: (priceInDollars) ->
        @engagementCapacity[@segment].minimum_purchase_in_cents = parseInt(priceInDollars || '0') * 100
        @inputChanged()

      setDefaultEngagementCapacity: ->
        engagementCapacity = JSON.parse(JSON.stringify(@engagementCapacity))
        engagementCapacity[@segment] ||= {}
        engagementCapacity[@segment].minimum_purchase_in_cents ||= null
        engagementCapacity[@segment].sampling_capacity ||= {}
        engagementCapacity[@segment].sampling_capacity.default ||= {}
        engagementCapacity[@segment].sampling_capacity.default.daily ||= null
        engagementCapacity[@segment].reach ||= {}
        engagementCapacity[@segment].reach.default ||= {}
        engagementCapacity[@segment].reach.default.daily ||= null
        @engagementCapacity = engagementCapacity

      loadMinimumPurchasePrice: ->
        priceInCents = @engagementCapacity[@segment].minimum_purchase_in_cents / 100
        priceInCents = null unless priceInCents
        @minimumPurchasePriceInDollars = priceInCents

      inputChanged: ->
        @$emit 'input', @engagementCapacity
        @$emit 'change', @engagementCapacity

export default VueOptions.vue settings
